export default __webpack_public_path__ + "static/media/BM_RenderCamera_11_BedroomB_02+Interior+Light_Scheme+Bedroom.7b9902fa.jpg";